module.exports = __webpack_public_path__ + "static/img/HRM_logo_2021_V_2048x1024.e0e351b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/HRM_logo_2021_V_2048x1024.png
// module id = I0m0
// module chunks = 1